module.exports = __webpack_public_path__ + "static/media/bot.ed50274f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/docs/examples/ChatWindow/bot.svg
// module id = 109
// module chunks = 0